import React, {  } from "react";
import "./Service_pages.scss";
import img from "./services/FMR.png"; // Replace with your actual image path
import img2 from "./services/dental.png";
import imgClinic from "./services/1.JPG";
import { FaCheckCircle, FaTooth, FaThumbsUp, FaUserMd, FaHeart, FaShieldAlt, FaClinicMedical, FaLaptopMedical } from 'react-icons/fa';
import { MdOutlineStarPurple500, MdOutlineHealthAndSafety, MdArchitecture } from "react-icons/md";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const FullMouthRehabilitation = () => {

    const types = [
        {
            title: "Restorative Reconstruction",
            icon: <FaTooth />,
            desc: "Comprehensive use of dental crowns, bridges, and inlays/onlays to rebuild the structure and strength of severely worn or damaged teeth.",
        },
        {
            title: "Implant & Surgical Solutions",
            icon: <MdOutlineHealthAndSafety />,
            desc: "Replacing multiple missing teeth with permanent dental implants to restore full chewing capacity and maintain jawbone integrity.",
        },
        {
            title: "Functional Bite Correction",
            icon: <MdArchitecture />,
            desc: "Advanced procedures to align the upper and lower jaws properly, relieving chronic jaw pain (TMJ) and preventing uneven tooth wear.",
        },
        {
            title: "Cosmetic Smile Design",
            icon: <MdOutlineStarPurple500 />,
            desc: "Integrating dental veneers and whitening to enhance the final aesthetics, ensuring your restored smile looks natural and beautiful.",
        },
    ];

    const disadvantages = [
        {
            title: "Treatment Duration",
            description: "As a comprehensive procedure, FMR is performed in stages and may require several months to complete for optimal healing and results.",
        },
        {
            title: "Significant Initial Investment",
            description: "Full mouth reconstruction involves multiple advanced procedures, making it a higher financial investment compared to single-tooth treatments.",
        },
        {
            title: "Multiple Appointments",
            description: "Patients must commit to a series of visits for detailed clinical examinations, diagnostic imaging, and iterative restoration phases.",
        },
        {
            title: "Adaptation Period",
            description: "As the bite alignment is corrected, some patients may need a short period to adjust to the new position of their teeth and jaw.",
        },
        {
            title: "Strict Maintenance",
            description: "The longevity of FMR results depends heavily on the patient’s commitment to superior oral hygiene and regular professional checkups.",
        },
    ];

    const benefits = [
        {
            category: "Functionality",
            benefit: "Restores Chewing Function",
            description: "Rebuilds damaged or missing units, allowing patients to eat and chew comfortably again.",
        },
        {
            category: "Functionality",
            benefit: "Corrects Bite Alignment",
            description: "Reduces stress on the jaw joint, eliminating chronic headaches and jaw pain.",
        },
        {
            category: "Oral Health",
            benefit: "Prevents Future Complications",
            description: "Addressing all issues simultaneously prevents the spread of decay and further bone loss.",
        },
        {
            category: "Oral Health",
            benefit: "Enhances Overall Health",
            description: "A healthy mouth reduces the risk of systemic conditions linked to untreated oral infections.",
        },
        {
            category: "Aesthetics",
            benefit: "Improves Facial Appearance",
            description: "Restoring missing teeth and vertical height supports facial structure and enhances smile aesthetics.",
        },
        {
            category: "Longevity",
            benefit: "Long-Lasting Results",
            description: "Modern biocompatible materials provide durable restorations designed to last for many years.",
        },
    ];

    const reasons = [
        {
            icon: <FaUserMd />,
            title: 'Highly Experienced Specialists',
            description: 'Our team combines restorative, cosmetic, and functional experts to handle complex rehabilitation cases.'
        },
        {
            icon: <FaLaptopMedical />,
            title: 'Advanced Digital Technology',
            description: 'We utilize CBCT imaging, digital scanners, and smile design software for 100% precision.'
        },
        {
            icon: <FaShieldAlt />,
            title: 'Customized Treatment Plans',
            description: 'Every rehabilitation is tailored specifically to the patient’s unique dental structure and aesthetic goals.'
        },
        {
            icon: <FaHeart />,
            title: 'Comfortable & Pain-Free',
            description: 'Advanced anesthesia and gentle techniques ensure a stress-free experience throughout the reconstruction.'
        },
        {
            icon: <FaThumbsUp />,
            title: 'Comprehensive Care',
            description: 'From root canals and implants to orthodontic corrections, we provide all FMR services under one roof.'
        },
        {
            icon: <FaClinicMedical />,
            title: 'Modern HSR Layout Facility',
            description: 'A hygienic, state-of-the-art environment designed to provide high-end clinical outcomes.'
        }
    ];

    return (
        <>
            <div className="service1-section">
                <Helmet>
                    <title>Full Mouth Rehabilitation in HSR Layout | Full Mouth Reconstruction Bengaluru</title>
                    <meta
                        name="description"
                        content="Restore function and aesthetics with Full Mouth Rehabilitation at Kosmix Dental Clinic, HSR Layout. Advanced treatments for worn, damaged, or missing teeth."
                    />
                    <link
                        rel="canonical"
                        href="https://www.kosmixdentalclinic.com/services/full-mouth-rehabilitation-in-hsr-layout"
                    />
                </Helmet>

                <div className="hero">
                    <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200" style={{ fontFamily: 'initial' }}>
                        Full Mouth Rehabilitation (FMR) in HSR Layout, Bengaluru
                    </h1>

                    <div className="hero-content">
                        <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
                            <img src={img} alt="Full Mouth Rehabilitation at Kosmix" />
                        </div>

                        <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
                            <p>
                                Severely damaged, worn, or missing teeth can affect not only your smile but also your ability to chew, speak, and maintain proper oral health.
                                <strong> Full Mouth Rehabilitation (FMR)</strong> is a comprehensive dental treatment designed to restore the function, health, and appearance of your entire mouth.
                            </p>
                            <p>
                                At Kosmix Dental Clinic in HSR Layout, Bengaluru, we offer advanced FMR treatments tailored to each patient’s unique needs. Our specialists combine
                                restorative, cosmetic, and functional dentistry to rebuild damaged teeth and correct complex bite problems.
                            </p>
                            <p>
                                Using modern digital technology and personalized planning, our team ensures long-lasting and natural-looking results for patients with severe dental neglect or trauma.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="content" data-aos="fade-up" data-aos-delay="300" >
                    <SectionTitle title="What is Full Mouth Rehabilitation?" />
                    <div className="text_first" >
                        <p1>
                            Full Mouth Rehabilitation (FMR), or Full Mouth Reconstruction, is a comprehensive dental procedure that restores all or most teeth in both the upper and lower jaws. It is not just a single treatment but a combination of procedures—including crowns, bridges, implants, and veneers—designed to rebuild oral health from the foundation up.
                        </p1>
                    </div>
                </div>

                <div className="compare-section">
                    <div className="compare-card crown-card" data-aos="fade-up" data-aos-delay="600">
                        <h3>Who Needs FMR?</h3>
                        <h6>
                            Rehabilitation is recommended for patients with multiple issues that cannot be resolved with a single procedure:
                        </h6>

                        <ul>
                            <li>Multiple missing teeth affecting speech or chewing.</li>
                            <li>Severely worn teeth due to long-term bruxism (grinding).</li>
                            <li>Chronic jaw pain, headaches, or bite misalignment.</li>
                            <li>Advanced decay or gum disease across several teeth.</li>
                            <li>Teeth damaged due to trauma, accidents, or neglect.</li>
                            <li>Broken or fractured teeth requiring structural support.</li>
                        </ul>
                    </div>

                    <div className="compare-card bridge-card" data-aos="fade-up" data-aos-delay="600">
                        <h3>Problems Treated with FMR</h3>
                        <h6>
                            Our clinical experts address a wide range of complex dental conditions simultaneously:
                        </h6>

                        <ul>
                            <li><strong>Severely Worn Teeth:</strong> Restoring shape and height lost to aging or acid.</li>
                            <li><strong>Bite Alignment:</strong> Correcting how teeth meet to reduce stress on the jaw.</li>
                            <li><strong>Missing Dentition:</strong> Using implants or bridges to restore full arches.</li>
                            <li><strong>Structural Damage:</strong> Repairing fractured teeth with premium crowns or veneers.</li>
                        </ul>
                    </div>
                </div>

                <section className="denture-guidance-hub" data-aos="fade-up">
                    <div className="content">
                        <SectionTitle title="Advanced Technology for FMR" />
                        <p className="text_first">
                            Precise results require the most advanced diagnostic tools available in modern dentistry:
                        </p>
                    </div>

                    <div className="guidance-list" data-aos="fade-up" data-aos-delay="100">
                        {[
                            { label: "CBCT Imaging:", text: "Provides high-resolution 3D evaluation of bone structure and jaw alignment." },
                            { label: "Digital Scanners:", text: "Eliminates messy impressions for highly accurate restoration designs." },
                            { label: "Digital Smile Design:", text: "Allows you to see a digital preview of your final smile before treatment starts." },
                            { label: "High-Powered Magnification:", text: "Ensures microscopic precision during restorative and surgical phases." },
                            { label: "Modern Materials:", text: "Utilization of premium Zirconia and E-max for long-term durability." },
                        ].map((item, index) => (
                            <div className="guidance-item" key={index}>
                                <FaCheckCircle className="guidance-icon" />
                                <span><strong>{item.label}</strong> {item.text}</span>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="why-choose-us">
                    <div className="wrapper">
                        <div className="image-side" data-aos="zoom-in" data-aos-delay="100">
                            <img src={img2} alt="Modern Dental Clinic Bengaluru" />
                        </div>

                        <div className="text-side" data-aos="fade-up" data-aos-delay="300">
                            <h2>Personalized Care for Every Patient</h2>
                            <p style={{ color: 'black' }}>
                                Every patient’s dental condition is unique, which is why Full Mouth Rehabilitation requires a highly customized approach at <strong>Kosmix Dental Clinic</strong>.
                            </p>

                            <div className="doctor-info" data-aos="fade-up" data-aos-delay="400">
                                <h3>Our Core Pillars of FMR</h3>
                                <div className="doctor">
                                    <span className="emoji">🦷</span>
                                    <div>
                                        <h4>Function First</h4>
                                        <p>Ensuring your bite is stable and your chewing ability is fully restored.</p>
                                    </div>
                                </div>
                                <div className="doctor">
                                    <span className="emoji">✨</span>
                                    <div>
                                        <h4>Aesthetic Excellence</h4>
                                        <p>Crafting restorations that look indistinguishable from natural teeth.</p>
                                    </div>
                                </div>
                            </div>

                            <p style={{ color: 'black' }}>
                                Proper oral hygiene and regular visits are essential to maintain these results. We provide night guards
                                if needed to protect your new restorations from grinding.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="crown-types-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="The Components of Rehabilitation" />
                        <p1 className="text_first">
                            Depending on your case, FMR integrates various advanced dental treatments into one cohesive plan.
                        </p1>
                    </div>

                    <div className="crown-grid">
                        {types.map((item, idx) => (
                            <div className="crown-card" key={idx} data-aos="zoom-in" data-aos-delay={idx * 200}>
                                <div className="icon">{item.icon}</div>
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="denture-guidance-hub" data-aos="fade-up">
                    <div className="content">
                        <SectionTitle title="Our Step-by-Step Treatment Process" />
                        <p className="text_first">
                            FMR is a carefully staged process to ensure success and long-term comfort:
                        </p>
                    </div>

                    <div className="guidance-list" data-aos="fade-up" data-aos-delay="100">
                        {[
                            { label: "Step 1 — Comprehensive Examination:", text: "Detailed evaluation of teeth, gums, and jaw alignment using 3D imaging and digital X-rays." },
                            { label: "Step 2 — Custom Treatment Planning:", text: "Developing a multi-phase plan tailored to your health needs, budget, and aesthetic goals." },
                            { label: "Step 3 — Restorative Phase:", text: "Performing required root canals, implant placements, or gum treatments to build a healthy foundation." },
                            { label: "Step 4 — Bite Adjustment & Alignment:", text: "Ensuring the upper and lower teeth meet properly to reduce jaw stress and improve longevity." },
                            { label: "Step 5 — Final Smile Restoration:", text: "Placement of final crowns, bridges, or veneers for a durable, functional, and beautiful result." },
                        ].map((item, index) => (
                            <div className="guidance-item" key={index}>
                                <FaCheckCircle className="guidance-icon" />
                                <span><strong>{item.label}</strong> {item.text}</span>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="advantages-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Considerations for Success" />
                        <p1 className="text_first">
                            Understanding the process is key to achieving the best possible clinical outcome:
                        </p1>
                    </div>

                    <div className="advantages-grid">
                        {disadvantages.map((item, index) => (
                            <div key={index} className="advantage-card" data-aos="fade-up" data-aos-delay={index * 100}>
                                <FaCheckCircle className="advantage-icon" />
                                <div>
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="benefits-section" data-aos="fade-up">
                    <div className="benefits-wrapper">
                        <div className="content">
                            <h2 className="section-title">Analysis of FMR Benefits</h2>
                        </div>
                        <div className="table-responsive">
                            <table className="styled-table">
                                <thead>
                                    <tr>
                                        <th>Benefit Category</th>
                                        <th>Specific Advantage</th>
                                        <th>Clinical Outcome</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {benefits.map((item, index) => (
                                        <tr key={index}>
                                            <td className="category-cell">
                                                {index === 0 || item.category !== benefits[index - 1].category ? item.category : ""}
                                            </td>
                                            <td>{item.benefit}</td>
                                            <td>{item.description}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>

                <section className="pricing-section" data-aos="fade-up">
                    <div className="pricing-content">
                        <div className="text-area">
                            <div className="content" data-aos="fade-up">
                                <SectionTitle title="Full Mouth Rehabilitation FAQs" />
                                <p>
                                    <strong>How long does it take?</strong> The duration varies based on complexity and healing times for implants or surgeries.
                                </p>
                                <p>
                                    <strong>Is the procedure painful?</strong> Most procedures are done under local anesthesia, ensuring a pain-free clinical experience.
                                </p>
                                <p>
                                    <strong>Are the results permanent?</strong> With proper hygiene and regular checkups, these results are designed to last for many years.
                                </p>
                            </div>
                        </div>

                        <div className="price-cards">
                            <div className="price-card">
                                <div className="tag">Suitability</div>
                                <h3 className="price">All Ages</h3>
                                <p className="desc">Ideal for older patients and trauma cases</p>
                                <ul className="details">
                                    <li>● Comprehensive Oral Exam</li>
                                    <li>● Improved Facial Structure</li>
                                    <li>● Restored Confidence</li>
                                </ul>
                            </div>

                            <div className="price-card premium">
                                <div className="tag premium-tag">Technology</div>
                                <h3 className="price">Digital Precision</h3>
                                <p className="desc">100% accurate diagnosis and planning</p>
                                <ul className="details">
                                    <li>● Digital Smile Preview</li>
                                    <li>● 3D CBCT Imaging</li>
                                    <li>● Premium Biocompatible Materials</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="fmr-why-choose-split">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Why Choose Kosmix for Full Mouth Rehabilitation?" />
                        <p1 className="text_first">
                            Our reputation for complex dental reconstruction in Bengaluru is built on specialist expertise and advanced clinical care:
                        </p1>
                    </div>

                    <div className="fmr-split-wrapper">
                        <div className="fmr-split-image" data-aos="fade-right" data-aos-delay="100">
                            <div className="fmr-image-frame">
                                <img src={imgClinic} alt="Kosmix Dental Clinic - Advanced Laser Dentistry" />
                                <div className="fmr-image-overlay">
                                    <span className="fmr-badge">HSR Layout, Bengaluru</span>
                                </div>
                            </div>
                            <div className="fmr-image-accent"></div>
                        </div>

                        <div className="fmr-split-reasons">
                            {reasons.map((reason, index) => (
                                <div
                                    className="fmr-reason-card"
                                    key={index}
                                    data-aos="fade-left"
                                    data-aos-delay={150 + index * 100}
                                >
                                    <div className="fmr-reason-icon">{reason.icon}</div>
                                    <div className="fmr-reason-body">
                                        <h3>{reason.title}</h3>
                                        <p>{reason.description}</p>
                                    </div>
                                    <div className="fmr-reason-index">{String(index + 1).padStart(2, '0')}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="cta-section" data-aos='zoom-in'>
                    <div className="cta-content">
                        <h2>
                            Restore Your Smile <span>Today!</span>
                        </h2>
                        <p>
                            Don't let complex dental problems hold you back. Schedule your consultation for Full Mouth Rehabilitation and regain your confidence.
                        </p>
                        <div className="cta-buttons">
                            <Link to="/#appointment">
                                <button className="btn-primary">Book FMR Consultation</button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

const SectionTitle = ({ title }) => (
    <h2 className="section-title">{title}</h2>
);

export default FullMouthRehabilitation;